import { useEffect } from 'react';
import { useState, useRef } from 'react';
import { useSelector } from 'react-redux';

export const Timer = ({ isBannerTimer, currentTime , className}) => {
  const [time, setTime] = useState({});
  const [isNegative, setIsNegative] = useState(false)
  const timerRef = useRef();
  const is_activation = useSelector(store => store?.userActivity?.is_activation)
  // The data/time we want to countdown to
  const countDownDate = currentTime ? new Date(new Date(currentTime).getTime() + (24 * 60 * 60 * 1000)) : (is_activation ?  (new Date().getTime() + 3*60*60*1000)  : new Date(new Date().toDateString() + ' 24:00:00').getTime());

  useEffect(
    () => {
      timerRef.current = setInterval(function () {
        const now = new Date().getTime();
        const timeleft = countDownDate - now;

        const hours = Math.floor(
          (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

        if (hours < 0 || minutes < 0 || seconds < 0) {
          setIsNegative(true);
        }
        // Result is output to the specific element
        // document.getElementById('days').innerHTML = days + 'd ';
        setTime({ h: hours, m: minutes, s: seconds });

        // Display the message when countdown is over
        if (timeleft < 0) {
          clearInterval(timerRef.current);
          // setTime to 0
        }
      }, 1000);
    },
    [],
    () => {
      clearInterval(timerRef.current);
    }
  );
  if (!isBannerTimer) {
    return (
      <>
     { !isNegative ?
      <div className={` font-bold text-red-500 ${className}`}>
        <div className="grid grid-cols-3 gap-x-2 w-32">
          <div className="text-center text-lg">{time?.h}</div>
          {/* <div className="row-span-2 text-center ">:</div> */}
          <div className="text-center text-lg">{time?.m}</div>
          {/* <div className="row-span-2 text-center">:</div> */}
          <div className="text-center text-lg">{time?.s}</div>
          <div className="text-center font-normal text-supertiny">Hours</div>
          <div className="text-center font-normal text-supertiny">Mins</div>
          <div className="text-center font-normal text-supertiny">Secs</div>
        </div>
      </div>: null
    }
    </>
    );

  } else {
    return (
      <>
        {
          !isNegative ?
            <div className="flex items-center justify-center font-bold text-red-800 border-2 text-xs md:text-lg border-red-800 bg-white rounded-md md:px-2 mx-2 md:mx-2 w-fit">
              <div className="flex gap-1 w-full px-2">
                <div className="text-center">{time?.h}H</div>
                <div className="row-span-1 md:row-span-2 text-center ">:</div>
                <div className="text-center">{time?.m}M</div>
                <div className="row-span-1 md:row-span-2 text-center">:</div>
                <div className="text-center">{time?.s}S</div>
                <div className="text-center">Left</div>
              </div>
            </div>
            : null
        }
      </>
    )
  }
};
